interface IENV {
  appCode: string
  /** chat-service gateway: every REST call. */
  apiEndpoint: string
  /**
   * chat-service WebSocket: ws://localhost:7010/chat/ws locally, wss://api-v1.erpboi.com/chat/chat/ws
   * on stage (the gateway strips one /chat/). Opened with a single-use ticket from POST /ws-ticket,
   * never with the JWT.
   */
  wsUrl: string
  envType?: string
  portalGetway: string
  portalURL?: string
  /**
   * Origin of `portalURL`: the Portal host, for cross-app links such as the profile menu.
   * Empty string when portalURL is unset or malformed.
   */
  portalOrigin: string
  /** This console's name, "Chat": part of the browser tab title. */
  appName: string
  /** Product name shown in the UI and appended to the browser tab title. */
  brandName: string
  /** Public path to this deployment's logo: the fallback when a company has no uploaded logo. */
  brandLogo: string
  /** Public path to this deployment's favicon. */
  brandFavicon: string
  /** Support address shown on the Help page. */
  supportEmail: string
}

const originOf = (url?: string): string => {
  try {
    return new URL(url || '').origin
  } catch {
    return ''
  }
}

export const ENV: IENV = {
  appCode: process.env.REACT_APP_CODE || '',
  envType: process.env.REACT_APP_ENV_TYPE || '',
  apiEndpoint: process.env.REACT_APP_GETWAY || '',
  wsUrl: process.env.REACT_APP_CHAT_WS_URL || '',
  portalURL: process.env.REACT_APP_PORTAL_URL || '',
  portalGetway: process.env.REACT_APP_PORTAL_GETWAY || '',
  portalOrigin: originOf(process.env.REACT_APP_PORTAL_URL),
  appName: process.env.REACT_APP_APP_NAME || 'Chat',
  brandName: process.env.REACT_APP_BRAND_NAME || 'ErpBoi',
  brandLogo: process.env.REACT_APP_BRAND_LOGO || '/media/logos/logo.png',
  brandFavicon: process.env.REACT_APP_BRAND_FAVICON || '/media/logos/favicon.ico',
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || 'support@erpboi.com',
}
